
import { Tag } from "primereact/tag";
import { classNames } from "primereact/utils";

const MeaContractTotalAmount = ({ contract, big }) => {
    const total = contract?.total_amount || 0;
    const currency = contract?.currency || "€"
    return (
        <>
            <Tag value={total + " " + currency} severity="success" style={{ backgroundColor: "gray" }} className={classNames(
                { "text-2xl": big === true }
            )} />
        </>
    );
};
export default MeaContractTotalAmount;
